// form_submission_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submitButton"];

  connect() {
    console.debug("Form Submission Controller connected");
    this.updateSubmitButtonState();

    // Listen for checkbox-disclosure changes
    this.element.addEventListener(
      "checkbox-disclosure:changed",
      this.handleDisclosureChange.bind(this),
    );
  }

  disconnect() {
    // Clean up event listener when controller disconnects
    this.element.removeEventListener(
      "checkbox-disclosure:changed",
      this.handleDisclosureChange.bind(this),
    );
  }

  handleDisclosureChange(event) {
    console.debug("Disclosure change detected", event.detail);
    this.updateSubmitButtonState();
  }

  updateSubmitButtonState() {
    // Find all checkbox-disclosure controllers in the form
    const checkboxes = this.element.querySelectorAll(
      '[data-controller~="checkbox-disclosure"] [data-checkbox-disclosure-target="mainToggle"]',
    );

    // Check if at least one is checked
    const anyChecked = Array.from(checkboxes).some(
      (checkbox) => checkbox.checked,
    );

    // Update submit button state
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !anyChecked;

      // Optionally update visual appearance
      if (anyChecked) {
        this.submitButtonTarget.classList.remove(
          "opacity-50",
          "cursor-not-allowed",
        );
      } else {
        this.submitButtonTarget.classList.add(
          "opacity-50",
          "cursor-not-allowed",
        );
      }
    }
  }
}
